module.exports = __webpack_public_path__ + "img/olc-screen-olc-5.37743573.jpg";